export const Field = ({ label, children }) => (
  <label className="block">
    <span className="field-label">{label}</span>
    {children}
  </label>
);

export const todayStr = () => new Date().toISOString().slice(0, 10);
